export interface BudgetRange {
  id: string;
  range: {
    en: string;
    zh: string;
  };
}

export const budgetRanges: BudgetRange[] = [
  {
    id: "budget_1",
    range: {
      en: "$10,000 - $50,000 HKD",
      zh: "$10,000 - $50,000 港幣",
    },
  },
  {
    id: "budget_2",
    range: {
      en: "$50,000 - $100,000 HKD",
      zh: "$50,000 - $100,000 港幣",
    },
  },
  {
    id: "budget_3",
    range: {
      en: "More than $100,000 HKD",
      zh: "多於 $100,000 港幣",
    },
  },
];

export default budgetRanges; 